/**
 * The webhook-failures closed sets, split out of `./webhook-failures.ts`
 * (#1805 A3b).
 *
 * Nothing here reaches a transport, for the reason spelled out in
 * `./review-queue.constants.ts`: `features/admin/components/webhookFailureBadges.ts`
 * derives its badge tables from these maps and is now reached from
 * `features/admin/widgets.tsx`, which `src/features/widgets.ts` pulls into
 * EVERY test suite ahead of any `vi.mock`. Reaching `./webhook-failures.ts` for
 * them would instantiate `@/lib/api` before a test could replace it.
 *
 * `./webhook-failures.ts` re-exports every member, so the
 * `@/services/webhook-failures` import path is unchanged for existing callers.
 */
import type { components } from '@/types/api.generated';

type WebhookFailureListItem = components['schemas']['WebhookFailureListItem'];

export const ERROR_KIND = {
  SIGNATURE_VERIFY_FAILED: 'signature_verify_failed',
  SECRET_MISCONFIGURED: 'secret_misconfigured',
  TOPIC_NOT_OWNED: 'topic_not_owned',
  SCHEMA_PARSE_FAILED: 'schema_parse_failed',
  D1_WRITE_FAILED: 'd1_write_failed',
  USE_CASE_THREW: 'use_case_threw',
} as const satisfies Record<string, WebhookFailureListItem['error_kind']>;
export type ErrorKind = (typeof ERROR_KIND)[keyof typeof ERROR_KIND];

export const PROVIDER = {
  SHOPIFY: 'shopify',
  ONFLEET: 'onfleet',
} as const satisfies Record<string, WebhookFailureListItem['provider']>;
export type Provider = (typeof PROVIDER)[keyof typeof PROVIDER];
